import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation('home');

  return (
    <footer className="bg-slate-900 text-white/80 py-8">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-sm text-white/80 text-center sm:text-left">
            <strong className="text-white">{t('footer.company')}</strong>
          </div>
          <a
            href="#top"
            className="inline-flex items-center text-sm font-medium bg-white/10 text-white px-4 py-2 rounded-md hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            {t('footer.backToTop')}
          </a>
        </div>
      </div>
    </footer>
  );
}